import PropTypes from 'prop-types';
import {
  Route,
  Redirect,
} from 'core/libs/router';

import withUser from 'core/hocs/withUser';
import { SimpleLoader } from 'core/components/Loader';

function PrivateRoute({ component: Component, ...rest }) {
  return (
    <Route {...rest} render={props => {
      // TODO: Заменить на какое-то превью.
      if (!rest.user.resolved) return <SimpleLoader />;

      if (!rest.user.isAuthorized) {
        return (
          <Redirect to={{
            pathname: '/',
            state: { from: props.location },
          }}
          />
        );
      }

      return <Component {...props} />;
    }}
    />
  );
}

PrivateRoute.propTypes = {
  component: PropTypes.func,
  location: PropTypes.object,
};

export default withUser(PrivateRoute);
